import React, { useEffect } from "react";
import Orange_Round_Arrow_Btn from "../Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import "./OrderSummary.css";
import Voucher_Lottie from "../../Animation/Voucher_Lottie/Voucher_Lottie";
import UpdateProfileModal from "../Common_Modal/UpdateProfileModal/UpdateProfileModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../../features/cart/cartSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup } from "react-bootstrap";
import OrangeFilledRoundBtn from "../Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import YellowFilledRoundBtn from "../Common_Btn/YellowFilledRoundBtn/YellowFilledRoundBtn";
import { useForm } from "react-hook-form";
import {
  CouponApplyed,
  OrderCalculation,
} from "../../../features/order/orderSlice";
import { useNavigate } from "react-router-dom";

const OrderSummary = ({ cart, order }) => {
  const [modalShow, setModalShow] = React.useState(false);

  const [CouponData, setCouponData] = React.useState("");

  const [orderData, setOrderData] = React.useState("");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    data.amount = cart?.data?.total;
    const res = await dispatch(CouponApplyed(data));

    if (res?.payload?.data) {
      setCouponData(res?.payload?.data);
    }
    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload?.errors,
      });
    }
  };

  const OrderCalculationData = async (coupon_id) => {
    const data = {
      coupon_id: coupon_id,
    };
    const res = await dispatch(OrderCalculation(data));

    if (res?.payload?.data) {
      setOrderData(res?.payload?.data);
    }
    if (res?.payload?.errors) {
      setError("code", {
        type: "manual",
        message: res.payload?.errors,
      });
    }
  };

  useEffect(() => {
    OrderCalculationData(CouponData?.id);
  }, [CouponData]);

  const nevigate = useNavigate();
  return (
    <>
      <section className="OrderSummary">
        <div className="OrderSummary_card_holder">
          <div className="heading_div">
            <p className="text">Order Summary</p>
          </div>

          <div className="data_container">
            <div className="value_holder">
              <div className="label_div">
                <div className="div1">
                  <p className="label">Sub Total</p>
                </div>
              </div>
              <div className="value_div">
                {/* <p className="value">₹{cart?.data?.data.reduce((sum, item) => sum + (item.Product_Combination?.total || 0), 0)}</p> */}
                <p className="value">₹{orderData?.order_summary?.subtotal}</p>
              </div>
            </div>

            <div className="value_holder">
              <div className="label_div">
                <div className="div1">
                  <p className="label">Offer Discount</p>
                </div>
              </div>
              <div className="value_div">
                {/* <p className="value">₹{cart?.data?.data.reduce((sum, item) => sum + (item.Product_Combination?.total || 0), 0)}</p> */}
                <p className="value">
                  ₹{orderData?.order_summary?.offer_discount}
                </p>
              </div>
            </div>

            <div className="value_holder">
              <div className="label_div">
                <div className="div1">
                  <p className="label">Coupon Discount</p>
                </div>
                {/* <div className="div2">
                  <p className="label2">(inclusive of all tax)</p>
                </div> */}
              </div>

              <div className="value_div">
                <p className="value">
                  ₹{orderData?.order_summary?.coupon_discount}
                </p>
              </div>
            </div>

            <div className="value_holder">
              <div className="label_div">
                <div className="div1">
                  <p className="label">Total Tax</p>
                </div>
              </div>
              <div className="value_div">
                {/* <p className="value">₹{cart?.data?.data.reduce((sum, item) => sum + (item.Product_Combination?.total || 0), 0)}</p> */}
                <p className="value">₹{orderData?.order_summary?.total_tax}</p>
              </div>
            </div>

            <div className="value_holder">
              <div className="label_div">
                <div className="div1">
                  <p className="label">Total</p>
                </div>
              </div>
              <div className="value_div">
                {/* <p className="value">₹{cart?.data?.data.reduce((sum, item) => sum + (item.Product_Combination?.total || 0), 0)}</p> */}
                <p className="value">₹{orderData?.order_summary?.total}</p>
              </div>
            </div>
          </div>

          {order && (
            <>
              <div className="voucher_holder mb-3">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <InputGroup className="">
                    <InputGroup.Text>
                      <div className="lottie_holder_div">
                        <Voucher_Lottie />
                      </div>
                    </InputGroup.Text>
                    <Form.Control
                      className="mb-0"
                      placeholder="Enter Coupon Code"
                      {...register("code", {
                        required: "Coupon code is required",
                      })}
                      readOnly={!!CouponData}
                    />
                    {CouponData && CouponData.id ? (
                      <InputGroup.Text
                        onClick={() => {
                          setCouponData("");
                          setValue("code", "");
                        }}
                      >
                        <b>Remove</b>
                      </InputGroup.Text>
                    ) : (
                      <InputGroup.Text as="button" type="submit">
                        <b>Apply</b>
                      </InputGroup.Text>
                    )}
                  </InputGroup>
                  {errors.code && (
                    <span className="text-danger small">
                      {errors.code.message}
                    </span>
                  )}
                </Form>
              </div>{" "}
              <div className="btn_holder">
                <Orange_Round_Arrow_Btn
                  btn_name="Continue To Checkout"
                  onClick={()=>setModalShow(true)}
                  // onClick={() => nevigate("/cart")}
                />
              </div>
            </>
          )}
        </div>
      </section>

      <UpdateProfileModal
        CouponData={CouponData}
        orderData={orderData}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default OrderSummary;
